import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  UntypedFormControl,
} from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { validateHTTPExists } from "../../shared/validators/url.validator";
import { DomainsService } from "../domains.service";
import { ToastrService } from "../../shared/toastr.service";
import { AuthService } from "../../auth/auth.service";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../shared/error-state-matcher";
import { AddDomainRequest } from "../domains.interface";

@Component({
  selector: "app-domains-create-dialog",
  templateUrl: "./domains-create-dialog.component.html",
  styleUrls: ["./domains-create-dialog.component.scss"],
  standalone: false,
})
export class DomainsCreateDialogComponent implements OnInit {
  form: FormGroup;
  loading = false;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<DomainsCreateDialogComponent>,
    private translate: TranslateService,
    private domainsService: DomainsService,
    private toastrService: ToastrService,
    public auth: AuthService,
  ) {
    this.form = this.fb.group({
      domain: [
        "",
        [
          (c: AbstractControl) => Validators.required(c),
          (c: AbstractControl) => validateHTTPExists(c as UntypedFormControl),
        ],
      ],
      googleAdminEmail: ["", (c: AbstractControl) => Validators.required(c)],
    });
  }

  ngOnInit(): void {}

  onSubmit(): void {
    this.errorStateMatcher.submitAttempted = true;
    if (this.form.invalid || this.loading) {
      return;
    }

    this.loading = true;
    const formValue = this.form.value as AddDomainRequest;
    const request: AddDomainRequest = {
      domain: formValue.domain,
      googleAdminEmail: formValue.googleAdminEmail,
    };

    this.domainsService.addDomain(request).subscribe({
      next: () => {
        this.loading = false;
        this.toastrService.success(
          this.translate.instant("domains.addSuccess") as string,
        );
        this.dialogRef.close(true);
      },
      error: () => {
        this.loading = false;
        this.toastrService.error(
          this.translate.instant("domains.addError") as string,
        );
      },
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
